(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mogofe-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupFilmHero = (root) => {
      if (!root || root.dataset.filmReady === 'true') return;

      const video = root.querySelector('.mogofe-hero__film');
      const toggle = root.querySelector('[data-film-toggle]');
      const toggleLabel = root.querySelector('[data-film-toggle-label]');
      const sound = root.querySelector('[data-film-sound]');
      const poster = root.querySelector('[data-film-poster]');
      if (!video || !toggle || !toggleLabel || !sound) return;

      root.dataset.filmReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileViewport = window.matchMedia('(max-width: 749px)');
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const labels = {
        play: root.dataset.playLabel,
        pause: root.dataset.pauseLabel,
        watchSound: root.dataset.watchSoundLabel,
        returnBackground: root.dataset.returnLabel,
      };
      let sourcesLoaded = false;
      let fullFilmMode = false;

      const loadSources = () => {
        if (sourcesLoaded) return;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        video.load();
        sourcesLoaded = true;
      };

      const updateToggle = () => {
        const paused = video.paused;
        toggleLabel.textContent = paused ? labels.play : labels.pause;
        toggle.setAttribute('aria-label', paused ? labels.play : labels.pause);
        toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');
      };

      const playBackground = () => {
        loadSources();
        fullFilmMode = false;
        video.controls = false;
        video.loop = true;
        video.muted = true;
        sound.textContent = labels.watchSound;
        video.play().then(updateToggle).catch(updateToggle);
      };

      const scheduleBackgroundPlayback = () => {
        if (reducedMotion.matches || mobileViewport.matches || connection?.saveData) {
          updateToggle();
          return;
        }
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(playBackground, { timeout: 4000 });
        } else {
          window.setTimeout(playBackground, 2400);
        }
      };

      toggle.addEventListener('click', () => {
        loadSources();
        if (video.paused) {
          video.play().then(updateToggle).catch(updateToggle);
        } else {
          video.pause();
          updateToggle();
        }
      });

      sound.addEventListener('click', () => {
        loadSources();
        if (fullFilmMode) {
          video.currentTime = 0;
          playBackground();
          return;
        }

        fullFilmMode = true;
        video.loop = false;
        video.controls = true;
        video.muted = false;
        video.currentTime = 0;
        sound.textContent = labels.returnBackground;
        video.play().then(updateToggle).catch(updateToggle);
      });

      video.addEventListener('playing', () => {
        if (poster instanceof HTMLElement) poster.hidden = true;
      });
      video.addEventListener('play', updateToggle);
      video.addEventListener('pause', updateToggle);
      video.addEventListener('ended', updateToggle);

      if (document.readyState === 'complete') {
        scheduleBackgroundPlayback();
      } else {
        window.addEventListener('load', scheduleBackgroundPlayback, { once: true });
      }
    };

    document.querySelectorAll('[data-mogofe-film-hero]').forEach(setupFilmHero);
    document.addEventListener('shopify:section:load', (event) => {
      setupFilmHero(event.target.querySelector('[data-mogofe-film-hero]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
